<div class="modal-overlay" *ngIf="isVisible" (click)="onOverlayClick($event)">
  <div class="modal-container">
    <!-- Close button -->
    <button class="close-button" (click)="onClose()">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 5L5 15M5 5L15 15"
          stroke="#15172E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <!-- Image section -->
    <div class="image-section content-animate">
      <div class="illustration-container">
        <!-- Success image from public assets -->
        <img src="/assets/images/sucess_img.svg" alt="Success" class="success-image" />
      </div>
    </div>

    <!-- Text section -->
    <div class="text-section content-animate">
      <h2 class="modal-title">{{ data.title }}</h2>

      <!-- Description - Only show if no order details -->
      <p class="modal-description" *ngIf="!hasOrderDetails">{{ data.description }}</p>

      <!-- Order Details Layout - Show when order details are available -->
      <div class="order-details-container" *ngIf="hasOrderDetails">
        <p class="order-description">{{ data.description }}</p>

        <div class="order-details-grid">
          <div class="order-detail-item" *ngIf="data.packageName">
            <div class="order-detail-label">CAR WASH PACKAGE</div>
            <div class="order-detail-value">{{ data.packageName }}</div>
          </div>

          <div class="order-detail-item" *ngIf="hasOrderDetails">
            <div class="order-detail-label">CUSTOMER NAME</div>
            <div class="order-detail-value">{{ displayCustomerName }}</div>
          </div>

          <div class="order-detail-item" *ngIf="vehicleDisplay">
            <div class="order-detail-label">VEHICLE</div>
            <div class="order-detail-value">{{ vehicleDisplay }}</div>
          </div>
        </div>
      </div>

      <!-- Family Plan sale: one row per plate -->
      <div class="plates-table-wrap" *ngIf="hasPlates">
        <p class="plates-warning" *ngIf="hasRefundedPlates" role="status">
          Some vehicles could not be added and were refunded.
        </p>
        <table class="plates-table">
          <thead>
            <tr>
              <th scope="col">PLATE</th>
              <th scope="col">ORDER</th>
              <th scope="col">CUSTOMER</th>
              <th scope="col">VEHICLE</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let plate of plates"
              [class.plates-table__row--refunded]="plate.status === 'refunded'"
            >
              <td>
                {{ plate.license_plate }}
                <span class="plates-table__tag" *ngIf="plate.role === 'primary'">Primary</span>
                <span
                  class="plates-table__tag plates-table__tag--refunded"
                  *ngIf="plate.status === 'refunded'"
                  >Refunded</span
                >
              </td>
              <td>{{ plate.package_name }}</td>
              <td>{{ plate.customer_name }}</td>
              <td>{{ plate.vehicle_name || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Time info badge (optional) -->
      <div class="time-info-badge" *ngIf="data.showTimeInfo && data.timeInfo && !hasOrderDetails">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" r="8.5" stroke="#B85900" stroke-width="1.5" />
          <path
            d="M10 6V10L13 13"
            stroke="#B85900"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>{{ data.timeInfo }}</span>
      </div>
    </div>

    <!-- Bottom section -->
    <div class="bottom-section content-animate">
      <div class="button-container">
        <button
          *ngIf="printInvoice.observed && !hasPlates"
          class="print-invoice-button"
          type="button"
          aria-label="Print Receipt"
          (click)="printInvoice.emit()"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M4 5V2h8v3"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <rect
              x="2"
              y="5"
              width="12"
              height="7"
              rx="1"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <path
              d="M4 9h8M4 12h8"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
          <span class="print-invoice-label">Print Receipt</span>
        </button>
        <button
          *ngIf="openGate.observed && data.showOpenGate"
          class="open-gate-button"
          type="button"
          [disabled]="isOpeningGate"
          [attr.aria-busy]="isOpeningGate"
          (click)="openGate.emit()"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 14V4l6-2 6 2v10"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 14h12M6 14V8h4v6"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Open Gate
        </button>
        <button class="okay-button" (click)="onAction()">
          {{ data.buttonText || 'Okay' }}
        </button>
      </div>
    </div>
  </div>
</div>
